import { render, staticRenderFns } from "./MostHeavilyInvested.vue?vue&type=template&id=777a38d7&"
import script from "./MostHeavilyInvested.vue?vue&type=script&lang=js&"
export * from "./MostHeavilyInvested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports